import {
  IDropdownItemExt,
  ISelectListItem,
  ISelectListItemExt,
} from "@ryde/shared";

const sortByLabel = (a: IDropdownItemExt, b: IDropdownItemExt): number =>
  String(a.label ?? "").localeCompare(String(b.label ?? ""));

const toSelectItem = (it: IDropdownItemExt): ISelectListItem => ({
  value: it.value,
  label: it.label,
  isActive: it.isActive,
  companyId: it.companyId,
});

const isCompanyRole = (it: IDropdownItemExt): boolean => Boolean(it.companyId);
const isGlobalRole = (it: IDropdownItemExt): boolean => !it.companyId;

/** Pre-built role list for DropdownTemplate (selectItems + boldValues). */
export const buildRoleDropdownSelectPresentation = ({
  items,
  isItemIncluded,
}: {
  items: IDropdownItemExt[];
  isItemIncluded: (item: IDropdownItemExt | ISelectListItemExt) => boolean;
}): {
  selectItems: ISelectListItem[];
  boldValues?: (number | string)[];
} => {
  const filtered = items.filter(isItemIncluded);
  const companyRoles = filtered.filter(isCompanyRole).sort(sortByLabel);
  const globalRoles = filtered.filter(isGlobalRole).sort(sortByLabel);
  const boldValues = companyRoles.map(it => it.value);

  return {
    selectItems: [...companyRoles, ...globalRoles].map(toSelectItem),
    boldValues: boldValues.length ? boldValues : undefined,
  };
};
